module.exports = __webpack_public_path__ + "somos3_0.png";